const queryKeys = {
  USER_PROFILE: 'user-profile',
  COMPANY_INFO: 'companyInfo',
}

export default queryKeys
